import { type ComponentProps, useState } from "react";
import { tv } from "tailwind-variants";

import { useAuth } from "@/hooks";
import { focusRing, icons } from "@/ui";
import { LogoutAlert } from "./modals/logout-alert";

const logoutButtonVariants = tv({
  base: `flex min-h-11 cursor-pointer items-center gap-2 rounded-lg px-3 py-2 text-content-secondary transition-colors hover:bg-surface-sunken hover:text-accent sm:text-lg ${focusRing}`,
});

export const LogoutButton = ({ className, ...props }: ComponentProps<"button">) => {
  const [logoutModalOpened, setLogoutModalOpened] = useState(false);
  const { mutate: logout } = useAuth().useLogout();

  return (
    <>
      <LogoutAlert
        isOpen={logoutModalOpened}
        onClose={() => {
          return setLogoutModalOpened(false);
        }}
        onLogout={() => {
          setLogoutModalOpened(false);
          void logout();
        }}
      />

      <button
        className={logoutButtonVariants({ className })}
        onClick={() => {
          return setLogoutModalOpened(true);
        }}
        type="button"
        {...props}
      >
        <icons.Logout aria-hidden="true" className="fill-current" height="24px" width="24px" />

        <span>Log out</span>
      </button>
    </>
  );
};
